module.exports = __webpack_public_path__ + "cc0c41a24e0ab6494bb9912fab097cbe.svg";